import React, { Component } from 'react';
import { connect } from 'react-redux';
import './privacyPolicy.scss';
import { Button } from 'antd';
import { fromValidate, history } from '../../../helpers'
import Header from "../../../layout/DefaultLayout/Header";
import AboutUsBanner from "../../../images/about-us-banner.png";

class AboutUs extends Component {

   constructor(props) {
      super(props);
      this.state = {
         formError: {},
         formSubmit: false,
         user: {},
         userNumber: '****7890',
         isSuccess: true,
      }
   }


   render() {
      const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
      return (
         <div>
            <Header></Header>
            <div>
            <img src={AboutUsBanner} className="about-background-img" alt="" />
            </div>
            <div className='policy-container'>
               <div className="main-heading-txt">Who Are We?</div>
               <div className="containt-container">
                  <div className="about-us-txt">BIDFHIRE is a subsidiary of <b>MODI TECH-PARK</b></div>
                  <div className="about-us-txt"><b>MODI TECH-PARK</b> began its business venture as an authorized service provider to 
                  popular companies like INTEK,SPICE and as third party service provider to Lenovo, Blackberry,Xiaomi,
                  Coolpad,Fly Wincom, Zen and many other brands.</div>
                  <div className="about-us-txt"><b>MODI TECH-PARK</b> has rendered excellent services to customers to the satisfaction of 
                  concerned companies.</div>
                  <div className="about-us-txt">In addition to this, it is rendering excellent services to customers in Home appliances 
                  sector for the products of Paramount, Ecopure, Haier, Whirlpool, Prestige,Havells,Cello, V-guard, Luminous, Micro tech,
                   Xiaomi, Oppo, Samsung etc.</div>
                   <div className="about-us-txt">At present <b>MODI TECH-PARK</b> is intiating a innovative way to provide  best quality 
                   services to customers at their door steps in their basic needs.</div>
                   <div className="about-us-txt">MODI TECH-PARK is now ready with <b>BIDFHIRE</b>, to provide quality services at 
                   reasonable rates by skilled & experienced professionals at your doorsteps.</div>
                   <div className="about-us-txt"><b>BIDFHIRE</b> will be helping the customers to hire trusted, efficient professionals for all services & needs.</div>
                   <div className="about-us-txt">We have team of young , passionate, efficient and sincere professionals such as plumbers, electricians, 
                   carpenters, beauticians,painters and pest controller etc etc.</div>
                   <div className="about-us-txt">The Uniqueness of BIDFHIRE  is , here customers can choose among service providers depending upon their 
                   service charges, past experiences and on their requirements etc,.</div>
                   <div className="about-us-txt"><b>BIDFHIRE</b> is pooling such skilled, trusted professionals whose background is thoroughly checked by us.</div>
                   <div className="about-us-txt">It will help you to hire the service through a single App.</div>
                   <div className="about-us-txt">Along with this, BIDFHIRE will be helping the service providers in this pandemic by getting them opportunities  
                   suitable to their skills and knowledge.</div>
                   <div className="about-us-txt">With constant hard work BIDFHIRE will aim to reach each and every corner so that customers get 
                   services sitting at their places. </div>
                   <div className="about-us-txt">We will be updating the customers by newer Digitalization techniques and best business practices.</div>
                   <div className="about-us-txt">We have confidence that we will exceed the expectations of customers by our excellent services and 
                   continuous interaction with them.
                   BIDFHIRE will be providing pleasant and nurturing environment to our skilled professionals also. So that they can render excellent 
                   services to customers and bloom personally and professionally.</div>
                   <div className="about-us-txt">Please be part of <b>BIDFHIRE</b> family....</div>
                 </div>

            </div>
         </div>
      )
   }
}

function mapStateToProps(state) {
   const { user } = state.authentication;
   return {
      user,
   }
}
export default connect(mapStateToProps)(AboutUs);